export default __webpack_public_path__ + "static/media/at-home.19d5a0ea.svg";